import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import lottie from 'lottie-web';
import { useStyles } from '../../hooks/useStyles/useStyles';
import { ThirdPartyAnimationStandAlone } from './thirdPartyAnimationStandAlone';
const THIRD_PARTY_ANIMATION_STYLES = 'THIRD_PARTY_ANIMATION_STYLES';
const ThirdPartyAnimationVariantComponent = ({ autoplay = true, loop = true, variant, ...props }, ref) => {
    const [animation, setAnimation] = React.useState();
    const variantTheme = useStyles(THIRD_PARTY_ANIMATION_STYLES, variant);
    const { thirdPartyAnimationData } = variantTheme;
    const element = React.useRef(null);
    React.useImperativeHandle(ref, () => {
        return element.current;
    }, []);
    React.useEffect(() => {
        if (element.current) {
            animation?.destroy();
            const newAnimation = lottie.loadAnimation({
                autoplay,
                loop,
                animationData: thirdPartyAnimationData,
                container: element.current,
            });
            setAnimation(newAnimation);
        }
        return () => {
            animation?.destroy();
        };
    }, [thirdPartyAnimationData]);
    return _jsx(ThirdPartyAnimationStandAlone, { ref: element, ...props });
};
const ThirdPartyAnimationVariant = React.forwardRef(ThirdPartyAnimationVariantComponent);
export { ThirdPartyAnimationVariant };
//# sourceMappingURL=thirdPartyAnimationVariant.js.map